module.exports = __webpack_public_path__ + "img/members.5a94aa0d.svg";